import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/all', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-900 hover:opacity-80 transition-opacity"
          >
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-play-circle-fill text-2xl text-primary-500"></i>
            </div>
            <span className="font-heading text-xl whitespace-nowrap">
              草莓视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.to ||
                  (link.to === '/category/all' && location.pathname.startsWith('/category'))
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors text-foreground-600 hover:text-foreground-900 cursor-pointer">
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/about"
              className="px-5 py-2 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              立即体验
            </Link>
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors text-foreground-700 cursor-pointer"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`block px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.to ||
                  (link.to === '/category/all' && location.pathname.startsWith('/category'))
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-4 py-2.5 mt-2 bg-primary-500 text-background-50 rounded-lg text-sm font-medium text-center hover:bg-primary-600 transition-colors"
            >
              立即体验
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}